import styled from '@emotion/styled';
import { Grid, useMediaQuery } from '@mui/material';
import { ExperienceMode } from '@/generated/graphql';
import LocationFilterButton from './location-filter-button';
import ModeFilterButton from './online-mode-filter-button';
import InPersonModeFilterButton from './in-person-mode-filter-button';
import AllExperiencesModeFilterButton from './all-experiences-mode-filter-button';
import OnineModeFilterButton from './online-mode-filter-button';
import { useParams, useSearchParams } from 'next/navigation';

const MainDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;

const UpperFilterButtons = styled(Grid)`
  width: auto;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  position: relative;
  border-radius: 100px;
  background-color: #fff3dc50;
  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-evenly;
    background-color: transparent;
    gap: 10px;
    padding: 10px;

    position: relative;
    border-radius: 20px;
    background: rgba(255, 243, 220, 0.5);
  }
`;

const ButtonPaddingBig = styled.div`
  padding-bottom: 100px;
  @media (max-width: 768px) {
    padding-bottom: 0px;
  }
`;

const ExploreFilters = () => {
  const params = useSearchParams();
  const mode = params.get('mode');
  return (
    <>
      <MainDiv>
        <UpperFilterButtons>
          <OnineModeFilterButton active={mode === ExperienceMode.Online} />
          <AllExperiencesModeFilterButton active={mode === null || mode === undefined} />
          <InPersonModeFilterButton active={mode === ExperienceMode.InPerson} />
        </UpperFilterButtons>
        <LocationFilterButton />
        <ButtonPaddingBig />
      </MainDiv>
    </>
  );
};

export default ExploreFilters;
